
import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "jobs-statistics-widget",
  setup() {
    const store = useStore();
    const key = ref<number>(0);

    const data = computed(
      () => store.getters["StatisticsModule/jobsStatistic"]
    );
    const chart = reactive({
      data: [
        {
          name: "Jobs",
          data: [] as string | unknown
        },
        {
          name: "Shifts",
          data: [] as string | unknown
        },
        {
          name: "Workers",
          data: [] as string | unknown
        }
      ],
      options: {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        noData: {
          text: "Loading..."
        },
        xaxis: {
          type: "category",
          categories: [] as string[]
        },
        tooltip: {
          x: {
            format: "MMM yyyy"
          }
        }
      }
    });
    const setData = () => {
      chart.options.xaxis.categories = Object.keys(data.value.jobs);
      chart.data[0].data = Object.values(data.value.jobs);
      chart.data[1].data = Object.values(data.value.shifts);
      chart.data[2].data = Object.values(data.value.applications);
      key.value++;
    };
    function fetchStatistics() {
      store.dispatch("StatisticsModule/fetchJobsStatistic").then(() => {
        setData();
      });
    }
    onMounted(() => {
      fetchStatistics();
    });
    return {
      chart,
      data,
      key
    };
  }
});
